import { useNuxtApp } from "#imports";
export function useI18n() {
  return useNuxtApp().$i18n;
}
